import {
  FETCH_ENROLLED_COURSES_FAILURE,
  FETCH_ENROLLED_COURSES_FAILURE_IDS,
  FETCH_ENROLLED_COURSES_REQUEST,
  FETCH_ENROLLED_COURSES_REQUEST_IDS,
  FETCH_ENROLLED_COURSES_SUCCESS,
  FETCH_ENROLLED_COURSES_SUCCESS_IDS,
} from "../Actions/types";

const initialState = {
  loading: false,
  enrolledCourses: [],
  enrolledCoursesIds: [],
  error: null,
};

const enrolledStudentCoursesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ENROLLED_COURSES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ENROLLED_COURSES_SUCCESS:
      return {
        ...state,
        loading: false,
        enrolledCourses: action.payload,
        error: null,
      };
    case FETCH_ENROLLED_COURSES_FAILURE:
      return {
        ...state,
        loading: false,
        enrolledCourses: [],
        error: action.payload,
      };
    case FETCH_ENROLLED_COURSES_REQUEST_IDS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ENROLLED_COURSES_SUCCESS_IDS:
      return {
        ...state,
        loading: false,
        enrolledCoursesIds: action.payload,
        error: null,
      };
    case FETCH_ENROLLED_COURSES_FAILURE_IDS:
      return {
        ...state,
        loading: false,
        enrolledCoursesIds: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default enrolledStudentCoursesReducer;
